
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField class="field field--single"
                                [label]="'Name on Account: (alphanumeric characters only)'"
                                id="name-on-account"
                                [text]="this.paymentAccount.holderName"
                                [disabled]="disabled"
                                (onValueChange)="updateInfo('holderName',$event)"
                                [validators]="[notBlankValidator]">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-6">
        <div class="input-wrapper">
            <ValidatedRadioButtonGroup id="account-type"
                                       label="Type of Account"
                                       radioGroupName="account-type-radio-group"
                                       [options]="accountTypeOptions"
                                       [selectedValue]="this.paymentAccount.type"
                                       [disabled]="disabled"
                                       (onValueChange)="updateInfo('type',$event)"
                                       [validators]="[notBlankValidator]">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField class="field field--single"
                                [label]="'Financial Institution: (alphanumeric characters only)'"
                                id="financial-institution"
                                [text]="this.paymentAccount.institution"
                                [disabled]="disabled"
                                (onValueChange)="updateInfo('institution',$event)"
                                [validators]="[notBlankValidator]">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField class="field field--single"
                                [label]="'Routing Number'"
                                id="routing-number"
                                [text]="this.paymentAccount.routingNumber"
                                (onValueChange)="updateInfo('routingNumber',$event)"
                                [maxlength]="9"
                                [disabled]="disabled"
                                [validators]="[notBlankValidator, routingNumberLengthValidator, numericValidator]">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField class="field field--single"
                                [label]="'Account Number'"
                                id="account-number"
                                [text]="this.paymentAccount.number"
                                [disabled]="disabled"
                                [maxlength]="15"
                                (onValueChange)="updateInfo('number',$event)"
                                [validators]="[notBlankValidator, numericValidator]">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row indented-container gray-card gray-card__section">
    <div class="col-24">
        <div class="bottom-20">
            <p><strong>Please have your client acknowledge the following:</strong></p>
            <!--<p>
                Your request for premium deduction will be submitted for the next available payment cycle. It may take one
                or more months for your deduction to begin. Please continue to pay your premium invoice as long as you
                receive it. If this request is received without a VOIDED check or savings account direct deposit form, your
                Automatic Bank Draft Withdrawal may not be processed.
            </p>
            <p>
                <i>
                    By selecting Automatic Bank Withdrawal, I authorize the bank or financial organization on the enclosed
                    check to pay my premium through electronic bank withdrawal payable to {{orgName}}. I
                    authorize the deduction of up to $300 per month to settle my current balance due. The bank or other
                    financial organization will be fully protected in honoring these payments until written notice from me
                    canceling this request is received at the address listed at the end of this form.
                </i>
            </p>-->
        </div>
    </div>
</div>

